<style lang="less" scoped>
    .paged-list {
        padding-top: 20px;

        .page {
            margin: 40px 0px 40px 0px;
        }
        .spin-container {
            width: 100%;
            height: 300px;
            position: relative;
            display: inline-block;
        }

        .spin-icon-load {
            animation: ani-spin 1.5s linear infinite;
        }
        @keyframes ani-spin {
            from {
                transform: rotate(0deg);
            }
            50% {
                transform: rotate(180deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    }
</style>

<template>
    <div class="paged-list">
        <Table class="list" ref="table" :stripe='stripe' border :columns="columns" :data="list" :highlight-row='highlight' :show-header='showHeader' :loading="loading" @on-selection-change="onChangeSelection" @on-row-click="onclickRow" @on-sort-change='sortCange'>
            <div class="spin-container" slot="loading">
                <Spin size="large" fix>
                    <Icon type="ios-loading" size="48" class="spin-icon-load"></Icon>
                </Spin>
            </div>
            <div class="spin-container" slot="footer" v-if='footerShow'>
                <slot name='footerData'></slot>
            </div>
        </Table>
        <div :style="pageFloat" v-if="pageList">
            <Page class="page"
                  :total="total" :current="page.page" :page-size="page.size"
                  @on-change="onChangePage" @on-page-size-change="onChangePageSize"
                  show-sizer show-elevator show-total :page-size-opts="pageSize"
            ></Page>
        </div>
    </div>

</template>

<script>
    export default {
        name: "PagedList",

        props: {
            loading: {
                type: Boolean,
                default: true
            },
            
            footerShow: {
                type: Boolean,
                default: false
            },
            highlight: {
                type: Boolean,
                default: false
            },
            showHeader: {
                type: Boolean,
                default: true
            },
            stripe: {
                type: Boolean,
                default: true
            },

            pageList: {
                type: Boolean,
                default: true
            },
            pageSize: {
                type: Array,
                default: function() {
                    return [10, 20, 50,100,400]
                }
            },
            total: {
                type: Number,
                default: 0
            },

            page: {
                type: Object,
                default: function () {
                    return {
                        page: 1,
                        size: 10
                    };
                }
            },

            list: {
                type: Array,
                default: function () {
                    return [];
                }
            },

            columns: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            pageFloat: {
               type: String,
               default: 'float: right;' 
            }
        },
        methods: {
            onChangePage(newPage) {
                this.$emit("changePage", {
                    page: newPage,
                    size: this.page.size
                });
            },

            onChangePageSize(newSize) {
                this.$emit("changePage", {
                    size: newSize,
                    page: this.page.page
                },"newSize");
            },

            onclickRow(row){
                this.$emit('clickRow',row);
            },

            onChangeSelection(selection){
                this.$emit('changeSelection',selection);
            },
            sortCange (row) {
                this.$emit('onSortCange',row);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// PagedList.vue?0d454700